import React from "react";

export interface CurrencySEOLayoutContextValue {
  deviceType: string | null;
  newAddCurrencyFunnel: boolean;
}

const defaultValue: CurrencySEOLayoutContextValue = {
  deviceType: null,
  newAddCurrencyFunnel: false,
};

export const CurrencySEOLayoutContext =
  React.createContext<CurrencySEOLayoutContextValue>(defaultValue);
